import { Pricing, PricingStatus } from "../../../pricingListSlice";
import { useContext } from "react";
import { ErrorByPartiesModalContext } from "../../../../pricing_list/components/ErrorByPartiesModal";
import { If } from "../../../../../common/components/If";
import { Button } from "@mui/material";

export function BookingErrorsCell(props: { pricing: Pricing }) {
	const errorByPartiesModalContext = useContext(ErrorByPartiesModalContext);

	return (
		<If
			condition={[PricingStatus.BOOKING_FAILED].includes(
				props.pricing.status
			)}
		>
			<Button
				variant="text"
				onClick={() =>
					errorByPartiesModalContext.setPricing(props.pricing)
				}
			>
				View Errors
			</Button>
		</If>
	);
}
